import { Button, Link, Stack, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import React, { useState } from "react";
import CustomInputLogin from "../../utils/CustomInputLogin";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { signInFormSchema } from "./shema";
import { post } from "../../utils/request";
import { useNavigate } from "react-router-dom";

export const SignInForm = ({ isBack = () => {} }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },

    setValue,
    clearErrors,
    reset,
    getValues,
  } = useForm({
    resolver: zodResolver(signInFormSchema),
  });

  const onSubmit = async ({ email }) => {
    setLoading(true);
    try {
      await post({
        path: `/auth/sing-in`,
        data: {
          email,
        },
      });
      reset();
      navigate("/sign-in-otp?email=" + encodeURIComponent(email));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <ArrowBack
        onClick={isBack}
        sx={{
          cursor: "pointer",
          color: "#a95052",
          "&:hover": { color: "#8c3e47" },
        }}
      />
      <Stack maxWidth={{ xs: "350px", md: "390px" }}>
        {/*  <Typography
          fontWeight="700"
          color="black"
          mb={2}
          textAlign={"left"}
          sx={{
            fontSize: "1.6rem",
            lineHeight: "2rem",
            letterSpacing: "-.025em",
          }}
        >
          Te damos la bienvenida a <br /> Plusval Estate
        </Typography> */}
        <Typography
          fontWeight={"500"}
          color="black"
          mb={2}
          textAlign={"left"}
          sx={{ fontSize: "1.06rem", lineHeight: "1.25rem", color: "#596173" }}
        >
          Ingresa tu correo electrónico para iniciar sesión en tu cuenta.
        </Typography>
        <Stack spacing={2}>
          <CustomInputLogin
            label="Email"
            disabled={loading}
            id="email"
            placeholder="Ingrese su Correo electrónico"
            onChange={(e) => {
              setValue("email", e.target.value);
              clearErrors("email");
            }}
            value={getValues("email")}
            isError={errors.email}
            errorMsg={errors.email?.message}
          />
          <Button
            type="submit"
            disabled={loading}
            variant="contained"
            sx={{
              backgroundColor: "#a95052",
              "&:hover": { backgroundColor: "#8c3e47" },
            }}
          >
            Continuar
          </Button>
        </Stack>{" "}
        <Typography
          fontWeight={"400"}
          color="black"
          mt={2}
          textAlign={"left"}
          sx={{ fontSize: "0.9rem", lineHeight: "1.25rem", color: "#596173" }}
        >
          Si no tienes una cuenta, regístrate haciendo click{" "}
          <Link
            sx={{
              color: "#a95052",
              "&:hover": { color: "#8c3e47" },
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/sign-up");
            }}
          >
            aqui.
          </Link>
        </Typography>
      </Stack>
    </form>
  );
};
